import React, {Fragment} from 'react';

import {ReportTemplateCreateCommons} from "./ReportTemplateEditCommons";



const ReportTemplateCreate = (props) => (
    <ReportTemplateCreateCommons {...props}/>
);



export default ReportTemplateCreate;